import styled from 'styled-components';
import { tokens } from '@splashthat/doppler';

// Establishes the container query context — Wrapper queries this element's inline size.
export const ContainerRoot = styled.div`
    container-type: inline-size;
    width: 100%;
    height: 100%;
`;

export const Wrapper = styled.div`
    font-size: clamp(4px, 2.7cqw, 8px);
    width: 100%;
    height: 100%;
    background: linear-gradient(
        135deg,
        ${tokens.color.accentLightContainer} 0%,
        ${tokens.color.accentLight} 40%,
        ${tokens.color.gray10} 100%
    );
    border-radius: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
`;

export const WatermarkOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.18;
`;

export const BackgroundImage = styled.img`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const ContentWrapper = styled.div`
    align-self: stretch;
    margin: 1.5625em;
    width: calc(100% - 3.125em);
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
`;

export const Card = styled.div`
    background: ${tokens.color.white};
    border-radius: 1em;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    border: 1.5px solid ${tokens.color.gray10};
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const CardHeader = styled.div`
    padding: 2.25em 2.5em 2em;
    display: flex;
    gap: 2em;
    align-items: center;
    flex: 1;
`;

export const TitleArea = styled.div`
    flex: 4;
    min-width: 0;
`;

export const InviteBadge = styled.div`
    display: inline-flex;
    align-items: center;
    color: ${tokens.color.accentPrimary};
    font-size: 0.6875em;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 0.25em 0.625em;
    border-radius: 1.25em;
    margin-bottom: 0.875em;
`;

export const EventTitle = styled.h1`
    font-size: 2.125em;
    font-weight: 700;
    color: ${tokens.color.primaryText};
    margin: 0;
    line-height: 1.15;
    letter-spacing: -0.02em;
    word-break: break-word;
`;

export const EventImageContainer = styled.div`
    flex: 5;
    align-self: stretch;
    border-radius: 0.75em;
    overflow: hidden;
    background: ${tokens.color.gray10};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const EventImage = styled.img`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.1em 2.5em;
    border-top: 1.5px solid ${tokens.color.gray10};
    gap: 1em;
`;

export const RegisterButton = styled.div`
    background: ${tokens.color.accentPrimary};
    color: ${tokens.color.white};
    font-size: 0.8125em;
    font-weight: 600;
    padding: 0.5625em 1.25em;
    border-radius: 0.5em;
    white-space: nowrap;
    letter-spacing: 0.01em;
`;

export const MetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75em;
    font-size: 0.8125em;
    color: ${tokens.color.secondaryText};
`;

export const MetaItem = styled.span`
    display: flex;
    align-items: center;
    gap: 0.4375em;
`;

export const MetaIconBadge = styled.span`
    width: 1.5em;
    height: 1.5em;
    background: ${tokens.color.accentLightContainer};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const MetaIconSvg = styled.svg`
    width: 0.8125em;
    height: 0.8125em;
    stroke: ${tokens.color.accentPrimary};
`;
